import { DraggableProvided, DraggableStateSnapshot } from 'react-beautiful-dnd';
import { WidgetsSetup } from 'components/posts/detail/layout/widgetsSetup/WidgetsSetupProvider';
import { lockAxisInTransformStyle } from 'app/modules/posts/utils/lockTransformAxisStyle';
import { Icon } from '@kontentino/ui';
import { faGripDotsVertical } from '@fortawesome/pro-regular-svg-icons/faGripDotsVertical';
import { createPortal } from 'react-dom';
import React, { FC } from 'react';
import clsx from 'clsx';
import { WIDGET_VARIANT_PROPERTIES } from 'app/modules/posts/components/accordionWidget/constants/widgetVariant';
import { useTranslation } from 'react-i18next';
type Props = {
  provided: DraggableProvided;
  snapshot: DraggableStateSnapshot;
  portal: HTMLElement | null;
  widget: WidgetsSetup;
};

const WidgetsSetupModalReorderableListItem: FC<Props> = ({
  provided,
  snapshot,
  portal,
  widget,
}) => {
  const { t } = useTranslation();
  const component = (
    <div
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      className={clsx(
        'tw-flex tw-select-none tw-items-center tw-gap-2 tw-rounded-sm tw-px-2 tw-py-1 hover:tw-bg-primary-10',
        {
          'tw-bg-primary-10': snapshot.isDragging,
        },
      )}
      style={lockAxisInTransformStyle('Y', provided.draggableProps.style)}
    >
      <Icon
        icon={faGripDotsVertical}
        className={clsx({
          'tw-text-primary-100': snapshot.isDragging,
          'tw-text-grayscale-100': !snapshot.isDragging,
        })}
      />
      <span
        className={clsx('tw-text-md tw-font-medium', {
          'tw-text-grayscale-180': !snapshot.isDragging,
          'tw-text-primary-100': snapshot.isDragging,
        })}
      >
        {WIDGET_VARIANT_PROPERTIES[widget.key]
          ? t(WIDGET_VARIANT_PROPERTIES[widget.key].title)
          : widget.key}
      </span>
    </div>
  );

  if (!snapshot.isDragging || !portal) return component;

  return createPortal(component, portal);
};

export default WidgetsSetupModalReorderableListItem;
